import { useState } from 'react'

const useToggle = (initialState: boolean = false) : [boolean, (S?: boolean) => void] => {
  const [ on, setOn ] = useState(initialState)

  const toggle = (state?: boolean) => {
    if(state !== undefined){
      setOn(state)
    }
    else setOn(prev => !prev)
  }

  return [
    on,
    toggle
  ]
}

export default useToggle
